type AuthLike = {
	user: { parent_id?: number | null } | null;
	grants: Map<string, string>;
};

/**
 * Instructor-portal grant check for a route `code`. Mirrors the backend's
 * `instructorCan:a,b` middleware: a comma separates alternatives (OR) and a
 * main instructor (no parent_id) always passes. A single code behaves exactly
 * as the old `grants.has(code)` did.
 */
export const hasRouteGrant = (auth: AuthLike, code: string | undefined): boolean => {
	if (!auth.user?.parent_id) return true;
	return (code ?? '').split(',').some((alternative) => auth.grants.has(alternative.trim()));
};

export default hasRouteGrant;
